document.addEventListener('DOMContentLoaded', function () {

  // Check if the current page is a product page using the URL
  const isProductPage = window.location.pathname.includes('/products/');

  // Only initialize swatch hover functionality on the product page
  if (!isProductPage) return;

  // Function to initialize swatch hover
  function initializeSwatchHover() {
    const swatches = document.querySelectorAll('.color-swatch'); // Select all swatches

    if (swatches.length === 0) return; // Exit if no swatches are found

    swatches.forEach(swatch => {
      const imageUrl = swatch.getAttribute('data-info-card-src'); // Get image URL

      // Only show popover if the image exists
      if (imageUrl && imageUrl !== 'null') {
        const img = new Image();
        img.src = imageUrl;

        // On successful image load, display the popover
        img.onload = function () {

          // Mouse enter event to show the popover
          swatch.addEventListener('mouseenter', function () {
            // Remove any existing info cards before showing the new one
            const existingInfoCard = document.querySelector('.info-card');
            if (existingInfoCard) {
              existingInfoCard.remove(); // Remove the previously shown info card
            }

            // Create and display the new info card
            const infoCard = document.createElement('img');
            infoCard.src = imageUrl;
            infoCard.classList.add('info-card');
            swatch.appendChild(infoCard);
            infoCard.style.opacity = '1';
            infoCard.style.transform = 'translate(-50%, 0)';
          });

          // Mouse leave event to hide the popover
          swatch.addEventListener('mouseleave', function () {
            const infoCard = swatch.querySelector('.info-card');
            if (infoCard) {
              infoCard.style.opacity = '0'; // Fade out the popover
              infoCard.style.transform = 'translate(-50%, 10px)'; // Optionally move the popover away
              setTimeout(() => {
                infoCard.remove(); // Remove the popover from the DOM after the animation
              }, 200); // Match the duration of the fade-out transition
            }
          });
        };

        // If image fails to load (i.e., doesn't exist), hide popover
        img.onerror = function () {
          console.log('Image not found:', imageUrl);
          // Prevent adding popover if image doesn't exist
          swatch.removeEventListener('mouseenter', showPopover);
        };
      }
    });
  }

  // Initialize on page load
  initializeSwatchHover();

  // Listen for variant changes (to reinitialize hover functionality)
  document.addEventListener('variant:change', function () {
    initializeSwatchHover();
  });

});
